import React, { createContext, useContext, useEffect, useState } from 'react'
import { AuthContext } from '../auth/AuthContext';
import axiosInstance from '../utils/RequestsQueue';
import {StatsContext} from '../stats/StatsContext';

export const ReviewContext = createContext()

export default function ReviewProvider({children}) {

    const {authToken} = useContext(AuthContext)
    const {fetchStats} = useContext(StatsContext)
    const [loading, setLoading] = useState(false)
    const [reviews, setReviews] = useState([])



    // ================== NEW REVIEW ================
    async function addNewReview(formData){
      if (!!authToken){
          setLoading(true)
          // console.log('Submited password:',password)
          try {
              const response = await axiosInstance.requestWithQueue({
                url: `${process.env.REACT_APP_SERVER_URL}/review/submit`,
                method:"POST",
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${authToken}`
                },
                data:formData
              })
              // console.log('Response:',response?.data)
              return response?.data
    
          } catch (error){
              // console.log('Error Response:',error?.response?.data)
              return error?.response?.data
          } finally {
              setLoading(false)
              fetchStats()
          }
      }
    }

  

    // ================== NEW REPLY ================
    async function addReviewReply(formData){
      if (!!authToken){
          setLoading(true)
          // console.log('Submited password:',password)
          try {
              const response = await axiosInstance.requestWithQueue({
                url: `${process.env.REACT_APP_SERVER_URL}/review/reply`,
                method:"POST",
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${authToken}`
                },
                data:formData
              })
              // console.log('Response:',response?.data)
              return response?.data
    
          } catch (error){
              // console.log('Error Response:',error?.response?.data)
              return error?.response?.data
          } finally {
              setLoading(false)
          }
      }
    }

  
    // ================== UPDATE REVIEW ================
    async function updateReview(formData){
      if (!!authToken){
          setLoading(true)
          // console.log('Submited password:',password)
          try {
              const response = await axiosInstance.requestWithQueue({
                url: `${process.env.REACT_APP_SERVER_URL}/review/update`,
                method:"PUT",
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${authToken}`
                },
                data:formData
              })
              // console.log('Response:',response?.data)
              return response?.data
    
          } catch (error){
              // console.log('Error Response:',error?.response?.data)
              return error?.response?.data
          } finally {
              setLoading(false)
          }
      }
    }

  
  
    // ================== UPDATE REPLY ================
    async function updateReply(formData){
      if (!!authToken){
          setLoading(true)
          // console.log('Submited password:',password)
          try {
              const response = await axiosInstance.requestWithQueue({
                url: `${process.env.REACT_APP_SERVER_URL}/review/update/reply`,
                method:"PUT",
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${authToken}`
                },
                data:formData
              })
              // console.log('Response:',response?.data)
              return response?.data
    
          } catch (error){
              // console.log('Error Response:',error?.response?.data)
              return error?.response?.data
          } finally {
              setLoading(false)
          }
      }
    }

  

    // ================== FETCH MY REVIEWS ================

    async function fetchMyReviews(){
      if (!!authToken){
          setLoading(true)
          // console.log('Submited password:',password)
          try {
              const response = await axiosInstance.requestWithQueue({
                url: `${process.env.REACT_APP_SERVER_URL}/review/all`,
                method:"GET",
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${authToken}`
                },
                // data:formData
              })
              // console.log('Response:',response?.data)
              return response?.data
    
          } catch (error){
              // console.log('Error Response:',error?.response?.data)
              return error?.response?.data
          } finally {
              setLoading(false)
          }
        }
      }
    

    // ================== FETCH ALL Reviews ================

    async function fetchPublicReviews(){
      // if (!!authToken){
          setLoading(true)
          // console.log('Submited password:',password)
          try {
              const response = await axiosInstance.requestWithQueue({
                url: `${process.env.REACT_APP_SERVER_URL}/review/public`,
                method:"GET",
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  // Authorization: `Bearer ${authToken}`
                },
                // data:formData
              })
              // console.log('Response:',response?.data)
              setReviews(response?.data?.data) 
    
          } catch (error){
              // console.log('Error Response:',error?.response?.data)
              console.error(error?.response?.data)
          } finally {
              setLoading(false)
          }
      }
    

      useEffect(() => {
        // Fetch once immediately
        fetchPublicReviews();
      
        // Set interval to fetch every 5 minutes (300,000 ms)
        const intervalId = setInterval(() => {
          fetchPublicReviews();
        }, 5 * 60 * 1000); // 5 minutes
      
        // Cleanup on unmount
        return () => clearInterval(intervalId);
      }, []);
        
  




const contextData ={
    loading,setLoading, addNewReview,updateReview,addReviewReply,updateReply,
    reviews, setReviews,
    fetchMyReviews

}
  return (
    <ReviewContext.Provider value={contextData}>
        {children}
    </ReviewContext.Provider>
  )
}
